// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"77f5131e","239":"ba423de0","455":"2c0e20fe"}[chunkId] + ".chunk.js";
};